<ng-container *ngIf="customObjType === 'Company' || customObjType === 'Contact' || isCustomObjectLookup">
  <div
    [ngClass]="{ readonly: readonly }"
    class="flex flex-row contact-wrapper p-2"
    style="min-height: 42px"
    tabindex="0"
  >
    <div class="flex flex-row items-center gap-2 w-full">
      <ng-container *ngIf="isNestedField">
        <div class="leading-5">
          {{ values.join(' | ') }}
        </div>
      </ng-container>

      <!-- non nested fields -->
      <ng-container *ngIf="!isMultipleField && !isNestedField">
        <span
          class="underline pointer inline"
          [class.locked]="fieldDef.locked"
          [class.opacity-30]="redirecting"
          (click)="value && !isDisabled && goToBaseRecord()"
        >
          {{ value }}
        </span>
      </ng-container>
      <ng-container *ngIf="isMultipleField && !editingMultipleField && !isNestedField">
        <span class="underline pointer" [class.locked]="fieldDef.locked">
          <ng-container *ngFor="let item of values; let i = index">
            <a (click)="item && !isDisabled && goToBaseRecord(item[0] + '|' + item[1])">{{
              item[1] | readableField: item[1] : fieldDef : item[1]
            }}</a
            ><ng-container *ngIf="i < values.length - 1">, </ng-container>
          </ng-container>
        </span>
      </ng-container>

      <ng-container
        *ngIf="editingMultipleField"
        [ngTemplateOutlet]="multipleRecordList"
        [ngTemplateOutletContext]="{ value: value }"
      ></ng-container>

      <ng-container *ngIf="showRecordActions">
        <button
          [class.always-visible]="isMultipleField && editingMultipleField"
          class="remove-email-field-editable mr-2"
          *ngIf="(!value && !isDisabled) || (!readonly && value?.length === 0) || editingMultipleField"
          type="button"
          mat-icon-button
          (click)="openContactModal(value)"
          matTooltip="Add {{ fieldDef.label }}"
        >
          <mat-icon [svgIcon]="'add_box'"></mat-icon>
        </button>
        <button
          *ngIf="!!value && value?.length > 0 && !isDisabled && !editingMultipleField"
          matSuffix
          mat-icon-button
          [matMenuTriggerFor]="menu"
          matTooltip="More actions"
          class="remove-email-field-editable mr-2"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </ng-container>

      <mat-menu #menu="matMenu">
        <ng-container *ngIf="value && !isDisabled">
          <button mat-menu-item (click)="openContactModal(value)" *ngIf="!isMultipleField">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="editingMultipleField = true" *ngIf="isMultipleField">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>

          <button mat-menu-item (click)="removeModelField($event)" *ngIf="!isMultipleField">
            <mat-icon>cancel</mat-icon>
            <span>Remove</span>
          </button>
        </ng-container>
      </mat-menu>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="customObjType === 'User'">
  <div (click)="edit()" (blur)="editing = false" *ngIf="!editing" style="min-height: 20px" class="editable">
    {{
      isMultipleField
        ? value
        : (value | treoFindByKey: 'id' : options)?.name || (value | treoFindByKey: 'id' : options)?.full_name
    }}
  </div>

  <div class="p-2" *ngIf="editing">
    <mat-form-field class="flex-auto pr-3 w-full">
      <mat-label>{{ fieldDef.label }}</mat-label>
      <div [matTooltip]="showTip" class="w-full">
        <mat-select
          [multiple]="isMultipleField"
          (selectionChange)="onSelectionChange($event)"
          [ngModel]="multipleUserIds || value"
          (ngModelChange)="multipleUserIds || (value = $event)"
          (openedChange)="openedChangedMultipleUser($event)"
          [disabled]="isDisabled"
        >
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let option of filteredOptions" [value]="option.id" [disabled]="!option?.active">{{
            option?.name || option?.full_name
          }}</mat-option>
        </mat-select>
      </div>
    </mat-form-field>
  </div>
</ng-container>

<ng-container *ngIf="customObjType === 'Engagement'">
  <div
    [ngClass]="{ readonly: readonly }"
    class="flex flex-row items-center contact-wrapper p-2"
    style="min-height: 42px"
    tabindex="0"
  >
    <div class="flex flex-row items-center justify-between w-full">
      <span class="underline truncate w-25 cursor-pointer" [class.locked]="fieldDef.locked" *ngIf="!editing">
        @if (value) {
          {{ value?.engagement_type }} on {{ value?.event_date | date: 'MMM dd, y' }}
        }
      </span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="customObjType === 'FileResource'">
  <div
    [ngClass]="{ readonly: readonly }"
    class="flex flex-row items-center contact-wrapper p-2"
    style="min-height: 42px"
    tabindex="0"
  >
    <div class="flex flex-row items-center justify-between w-full" *ngIf="!uploadingFile">
      <span
        class="underline truncate w-25 cursor-pointer"
        [class.locked]="fieldDef.locked"
        (click)="viewFile(fileResource)"
        *ngIf="!editing"
      >
        {{ value }}
      </span>

      <ng-container
        *ngIf="editing"
        [ngTemplateOutlet]="multipleRecordList"
        [ngTemplateOutletContext]="{ value: value }"
      ></ng-container>

      <button
        class="remove-email-field-editable mr-1"
        *ngIf="(!value || value?.length === 0) && !readonly"
        type="button"
        mat-icon-button
        (click)="addFileInput.click()"
        matTooltip="Add File"
      >
        <mat-icon [svgIcon]="'add_box'"></mat-icon>
        <input style="display: none" type="file" (change)="onFileChanged($event)" #addFileInput />
      </button>

      <div class="flex flex-row items-center ml-2" *ngIf="value?.length > 0 && !readonly">
        <button
          class="remove-email-field-editable mr-2"
          *ngIf="!isDisabled && !editing"
          type="button"
          mat-icon-button
          (click)="isMultipleField ? (editing = true) : editFileInput.click()"
          matTooltip="Edit"
        >
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          <input style="display: none" type="file" (change)="onFileChanged($event)" #editFileInput />
        </button>

        <button
          class="remove-email-field-editable mr-2"
          *ngIf="!isDisabled && editing"
          type="button"
          mat-icon-button
          (click)="editing = false"
          matTooltip="Edit"
        >
          <mat-icon [svgIcon]="'close'"></mat-icon>
          <input style="display: none" type="file" (change)="onFileChanged($event)" #editFileInput />
        </button>

        <button
          class="remove-email-field-editable mr-1"
          *ngIf="!isDisabled && isMultipleField"
          type="button"
          mat-icon-button
          (click)="addFileInput.click()"
          matTooltip="Add File"
        >
          <mat-icon [svgIcon]="'add_box'"></mat-icon>
          <input style="display: none" type="file" (change)="onFileChanged($event)" #addFileInput />
        </button>
      </div>
    </div>
    <mat-progress-bar *ngIf="uploadingFile" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-container>

<ng-container *ngIf="hasNoRecordType()">
  <div
    class="editable"
    *ngIf="!editing"
    (click)="edit()"
    (focus)="edit()"
    tabindex="-1"
    [ngClass]="{ readonly: readonly }"
    [matTooltip]="showTip"
  >
    <ng-container *ngIf="value">
      <div class="flex flex-row">
        <task-status [task]="value" [taskStatuses]="workflowStates" (onUpdate)="updateTask(value)"></task-status>
        <a (click)="goToRecord()">
          <div class="flex flex-col">
            <span class="font-semibold leading-none">{{ value.title }}</span>
            <span class="text-sm text-secondary leading-none mt-1">
              <span *ngIf="value.due_date">{{ value.due_date | date: 'LLL dd, y' }}</span>
              <span *ngIf="value.assigned_user_name">• {{ value.assigned_user_name }}</span>
            </span>
          </div>
        </a>
      </div>
    </ng-container>
  </div>
  <input
    #inputEditorControl
    type="text"
    *ngIf="editing"
    (blur)="onBlur($event)"
    (keyup.enter)="onBlur($event)"
    [(ngModel)]="value"
    [disabled]="isDisabled"
  />
</ng-container>

<!-- RECORD MULTIPLE INPUT -->
<ng-template let-value="value" #multipleRecordList>
  <mat-chip-list #chipList class="my-0">
    <mat-chip
      class="small-chip"
      *ngFor="let item of value"
      [removable]="true"
      (removed)="removeItem(item)"
      (click)="goToBaseRecord(item)"
    >
      {{ item.split('|')[1] }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
</ng-template>
